/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import Tysiav2BoardsClipboardIcon from 'DesignSystem/Svgs/Tysiav2BoardsClipboardIcon/index'
import Tysiav2IconEditFilled from 'DesignSystem/Svgs/Tysiav2IconEditFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/ActionsAction/Content",
  ignoreClickOutsideIf
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  ignoreClickOutsideIf
  
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 title="Mark as done"
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2BoardsClipboardIcon
  viewPath={`${viewPath}/Tysiav2BoardsClipboardIcon`}
 width={12}
 height={14}
 fill2="#9AA5B1"
/>
</button>
<Popover
  viewPath={`${viewPath}/Popover`}
 ignoreClickOutsideIf={ignoreClickOutsideIf}
 placement="bottom"
 offsetMainAxis={4}
 offsetCrossAxis={-100}
 width={240}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2IconEditFilled
  viewPath={`${viewPath}/Tysiav2IconEditFilled`}
 width={12}
 height={12}
/>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}